import type { Comic, ComicCategory } from '@/types/comic';

export const categories: ComicCategory[] = [
  { slug: 'all', name: '全部', description: '浏览所有韩国漫画作品' },
  { slug: 'romance', name: '恋爱', description: '甜蜜浪漫的韩国恋爱漫画' },
  { slug: 'fantasy', name: '奇幻', description: '充满想象力的奇幻冒险漫画' },
  { slug: 'action', name: '动作', description: '热血刺激的动作打斗漫画' },
  { slug: 'thriller', name: '悬疑', description: '扣人心弦的悬疑推理漫画' },
  { slug: 'slice-of-life', name: '日常', description: '温馨治愈的日常生活漫画' },
  { slug: 'drama', name: '剧情', description: '深刻感人的剧情向漫画' },
];

export const comics: Comic[] = [
  {
    id: 'comic-001',
    title: '甜蜜的谎言',
    author: '金智媛',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20romance%20comic%20cover%20art%2C%20beautiful%20young%20couple%20holding%20hands%20under%20cherry%20blossom%20trees%2C%20soft%20pastel%20pink%20and%20white%20color%20palette%2C%20manga%20style%20illustration%20with%20clean%20lines%2C%20simple%20gradient%20background%2C%20romantic%20atmosphere%2C%20Korean%20manhwa%20aesthetic%2C%20light%20and%20airy%20composition&width=400&height=560&seq=comic-cover-001&orientation=portrait',
    description: '从小被谎言包围的她，遇到了唯一一个愿意对她说真话的人。然而，这份真挚的感情却被一个又一个的秘密所困扰。当真相浮出水面，他们的爱情还能继续吗？一部关于信任与救赎的浪漫故事。',
    category: 'romance',
    tags: ['恋爱', '校园', '治愈'],
    status: '连载中',
    updateDate: '2026-08-03',
    views: 1285600,
    rating: 4.8,
    chapters: [
      { id: 'ch-001-1', title: '第1话 命运的相遇', number: 1, updateDate: '2026-06-01', pages: [] },
      { id: 'ch-001-2', title: '第2话 隐藏的秘密', number: 2, updateDate: '2026-06-08', pages: [] },
      { id: 'ch-001-3', title: '第3话 心跳加速', number: 3, updateDate: '2026-06-15', pages: [] },
      { id: 'ch-001-4', title: '第4话 无法逃避', number: 4, updateDate: '2026-06-22', pages: [] },
      { id: 'ch-001-5', title: '第5话 真心的告白', number: 5, updateDate: '2026-06-29', pages: [] },
      { id: 'ch-001-6', title: '第6话 暴风雨前', number: 6, updateDate: '2026-07-06', pages: [] },
      { id: 'ch-001-7', title: '第7话 破碎的信任', number: 7, updateDate: '2026-07-13', pages: [] },
      { id: 'ch-001-8', title: '第8话 重新开始', number: 8, updateDate: '2026-07-20', pages: [] },
      { id: 'ch-001-9', title: '第9话 温暖的拥抱', number: 9, updateDate: '2026-07-27', pages: [] },
      { id: 'ch-001-10', title: '第10话 新的旅程', number: 10, updateDate: '2026-08-03', pages: [] },
    ],
  },
  {
    id: 'comic-002',
    title: '剑与魔法',
    author: '李东旭',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20comic%20cover%2C%20hero%20holding%20glowing%20sword%20in%20epic%20battle%20pose%2C%20magical%20energy%20surrounding%2C%20dark%20fantasy%20castle%20background%2C%20dramatic%20lighting%20with%20blue%20and%20gold%20tones%2C%20detailed%20armor%20design%2C%20manga%20art%20style%2C%20cinematic%20composition&width=400&height=560&seq=comic-cover-002&orientation=portrait',
    description: '在一个剑与魔法并存的世界里，平凡的少年意外觉醒了传说中的剑术天赋。从此踏上了成为最强剑士的冒险之旅。面对强大的敌人和未知的挑战，他能否守护自己所珍视的一切？',
    category: 'fantasy',
    tags: ['奇幻', '冒险', '热血'],
    status: '连载中',
    updateDate: '2026-08-02',
    views: 2356700,
    rating: 4.9,
    chapters: [
      { id: 'ch-002-1', title: '第1话 觉醒之日', number: 1, updateDate: '2026-05-15', pages: [] },
      { id: 'ch-002-2', title: '第2话 初入学院', number: 2, updateDate: '2026-05-22', pages: [] },
      { id: 'ch-002-3', title: '第3话 试炼开始', number: 3, updateDate: '2026-05-29', pages: [] },
      { id: 'ch-002-4', title: '第4话 隐藏的力量', number: 4, updateDate: '2026-06-05', pages: [] },
      { id: 'ch-002-5', title: '第5话 命运的对手', number: 5, updateDate: '2026-06-12', pages: [] },
      { id: 'ch-002-6', title: '第6话 突破极限', number: 6, updateDate: '2026-06-19', pages: [] },
      { id: 'ch-002-7', title: '第7话 王都危机', number: 7, updateDate: '2026-06-26', pages: [] },
      { id: 'ch-002-8', title: '第8话 龙之谷', number: 8, updateDate: '2026-07-03', pages: [] },
      { id: 'ch-002-9', title: '第9话 决战前夕', number: 9, updateDate: '2026-07-10', pages: [] },
      { id: 'ch-002-10', title: '第10话 觉醒的传说', number: 10, updateDate: '2026-07-17', pages: [] },
      { id: 'ch-002-11', title: '第11话 新的敌人', number: 11, updateDate: '2026-07-24', pages: [] },
    ],
  },
  {
    id: 'comic-003',
    title: '暗夜追踪者',
    author: '朴成勋',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20thriller%20cover%2C%20dark%20alley%20at%20night%20with%20mysterious%20detective%20in%20long%20coat%2C%20neon%20city%20lights%20reflecting%20on%20wet%20street%2C%20noir%20film%20atmosphere%2C%20deep%20shadows%20and%20high%20contrast%2C%20manga%20illustration%20style%2C%20suspenseful%20mood%2C%20urban%20nighttime%20setting&width=400&height=560&seq=comic-cover-003&orientation=portrait',
    description: '首尔深夜的街头，一系列离奇的失踪案引起了刑警姜赫的注意。随着调查的深入，一个庞大的地下组织逐渐浮出水面。在真相与危险之间，他必须做出选择。',
    category: 'thriller',
    tags: ['悬疑', '犯罪', '都市'],
    status: '连载中',
    updateDate: '2026-08-01',
    views: 987300,
    rating: 4.7,
    chapters: [
      { id: 'ch-003-1', title: '第1话 深夜来电', number: 1, updateDate: '2026-06-10', pages: [] },
      { id: 'ch-003-2', title: '第2话 第一个线索', number: 2, updateDate: '2026-06-17', pages: [] },
      { id: 'ch-003-3', title: '第3话 地下世界', number: 3, updateDate: '2026-06-24', pages: [] },
      { id: 'ch-003-4', title: '第4话 卧底行动', number: 4, updateDate: '2026-07-01', pages: [] },
      { id: 'ch-003-5', title: '第5话 身份暴露', number: 5, updateDate: '2026-07-08', pages: [] },
      { id: 'ch-003-6', title: '第6话 绝地求生', number: 6, updateDate: '2026-07-15', pages: [] },
      { id: 'ch-003-7', title: '第7话 幕后黑手', number: 7, updateDate: '2026-07-22', pages: [] },
      { id: 'ch-003-8', title: '第8话 最终对决', number: 8, updateDate: '2026-07-29', pages: [] },
    ],
  },
  {
    id: 'comic-004',
    title: '邻家咖啡香',
    author: '崔秀英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20slice%20of%20life%20cover%2C%20cozy%20coffee%20shop%20interior%20with%20warm%20lighting%2C%20young%20barista%20smiling%20behind%20counter%2C%20plants%20and%20books%20decorating%20the%20space%2C%20soft%20beige%20and%20brown%20tones%2C%20gentle%20atmosphere%2C%20manga%20illustration%20style%2C%20comforting%20and%20peaceful%20vibe&width=400&height=560&seq=comic-cover-004&orientation=portrait',
    description: '辞去大公司工作的她，在一条安静的小巷里开了一家属于自己的咖啡店。每一天都有不同的客人带来不同的故事，而她也在这过程中找到了生活的真正意义。',
    category: 'slice-of-life',
    tags: ['日常', '美食', '治愈'],
    status: '已完结',
    updateDate: '2026-07-15',
    views: 756200,
    rating: 4.6,
    chapters: [
      { id: 'ch-004-1', title: '第1话 新的开始', number: 1, updateDate: '2026-03-01', pages: [] },
      { id: 'ch-004-2', title: '第2话 第一位客人', number: 2, updateDate: '2026-03-08', pages: [] },
      { id: 'ch-004-3', title: '第3话 雨天的温暖', number: 3, updateDate: '2026-03-15', pages: [] },
      { id: 'ch-004-4', title: '第4话 旧友重逢', number: 4, updateDate: '2026-03-22', pages: [] },
      { id: 'ch-004-5', title: '第5话 意外的告白', number: 5, updateDate: '2026-03-29', pages: [] },
      { id: 'ch-004-6', title: '第6话 选择的勇气', number: 6, updateDate: '2026-04-05', pages: [] },
      { id: 'ch-004-7', title: '第7话 春天的约定', number: 7, updateDate: '2026-04-12', pages: [] },
      { id: 'ch-004-8', title: '第8话 最终话 新的日常', number: 8, updateDate: '2026-04-19', pages: [] },
    ],
  },
  {
    id: 'comic-005',
    title: '王室的秘密',
    author: '尹素熙',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20cover%2C%20elegant%20princess%20in%20traditional%20Korean%20hanbok%20standing%20in%20palace%20courtyard%2C%20moonlight%20illuminating%20the%20scene%2C%20intricate%20architectural%20details%2C%20soft%20golden%20and%20crimson%20color%20scheme%2C%20manga%20style%20art%2C%20mysterious%20and%20romantic%20atmosphere&width=400&height=560&seq=comic-cover-005&orientation=portrait',
    description: '朝鲜王朝时期，一位身份卑微的宫女意外发现了王室隐藏百年的秘密。这个秘密不仅关乎她的身世，更可能颠覆整个王朝的命运。在权力与爱情之间，她将如何抉择？',
    category: 'drama',
    tags: ['剧情', '古风', '权谋'],
    status: '已完结',
    updateDate: '2026-06-20',
    views: 1845200,
    rating: 4.9,
    chapters: [
      { id: 'ch-005-1', title: '第1话 入宫', number: 1, updateDate: '2026-01-10', pages: [] },
      { id: 'ch-005-2', title: '第2话 禁地', number: 2, updateDate: '2026-01-17', pages: [] },
      { id: 'ch-005-3', title: '第3话 密信', number: 3, updateDate: '2026-01-24', pages: [] },
      { id: 'ch-005-4', title: '第4话 王世子', number: 4, updateDate: '2026-01-31', pages: [] },
      { id: 'ch-005-5', title: '第5话 阴谋', number: 5, updateDate: '2026-02-07', pages: [] },
      { id: 'ch-005-6', title: '第6话 真相', number: 6, updateDate: '2026-02-14', pages: [] },
      { id: 'ch-005-7', title: '第7话 政变', number: 7, updateDate: '2026-02-21', pages: [] },
      { id: 'ch-005-8', title: '第8话 牺牲', number: 8, updateDate: '2026-02-28', pages: [] },
      { id: 'ch-005-9', title: '第9话 加冕', number: 9, updateDate: '2026-03-06', pages: [] },
      { id: 'ch-005-10', title: '第10话 终章 太平盛世', number: 10, updateDate: '2026-03-13', pages: [] },
    ],
  },
  {
    id: 'comic-006',
    title: '心跳补习班',
    author: '韩智恩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20school%20romance%20cover%2C%20two%20high%20school%20students%20studying%20together%20in%20classroom%20after%20school%2C%20sunset%20golden%20light%20through%20windows%2C%20shy%20glances%20between%20them%2C%20warm%20orange%20and%20yellow%20tones%2C%20manga%20art%20style%2C%20youthful%20and%20sweet%20atmosphere&width=400&height=560&seq=comic-cover-006&orientation=portrait',
    description: '全校第一的学霸和全校倒数第一的学渣被分配到了同一个学习小组。本以为是一场灾难，却意外擦出了不一样的火花。青春校园里的甜蜜补习时光就此展开。',
    category: 'romance',
    tags: ['恋爱', '校园', '喜剧'],
    status: '连载中',
    updateDate: '2026-08-03',
    views: 1560300,
    rating: 4.7,
    chapters: [
      { id: 'ch-006-1', title: '第1话 冤家路窄', number: 1, updateDate: '2026-05-20', pages: [] },
      { id: 'ch-006-2', title: '第2话 图书馆风波', number: 2, updateDate: '2026-05-27', pages: [] },
      { id: 'ch-006-3', title: '第3话 意外的默契', number: 3, updateDate: '2026-06-03', pages: [] },
      { id: 'ch-006-4', title: '第4话 放学后的约定', number: 4, updateDate: '2026-06-10', pages: [] },
      { id: 'ch-006-5', title: '第5话 运动会', number: 5, updateDate: '2026-06-17', pages: [] },
      { id: 'ch-006-6', title: '第6话 暑假前夕', number: 6, updateDate: '2026-06-24', pages: [] },
      { id: 'ch-006-7', title: '第7话 海边之旅', number: 7, updateDate: '2026-07-01', pages: [] },
      { id: 'ch-006-8', title: '第8话 心动的瞬间', number: 8, updateDate: '2026-07-08', pages: [] },
    ],
  },
  {
    id: 'comic-007',
    title: '末日生存法则',
    author: '郑宇成',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20post%20apocalyptic%20action%20cover%2C%20survivor%20with%20weapon%20standing%20on%20ruined%20city%20rooftop%2C%20orange%20dusk%20sky%2C%20destroyed%20buildings%20in%20background%2C%20dust%20and%20debris%2C%20intense%20and%20dramatic%20mood%2C%20manga%20illustration%20style%2C%20survival%20theme%2C%20cinematic%20wide%20composition&width=400&height=560&seq=comic-cover-007&orientation=portrait',
    description: '一场突如其来的病毒席卷全球，文明在一夜之间崩塌。幸存者们必须在这片废土上寻找生存的希望。前特种兵金泰浩带领着一群幸存者，在绝望中开辟出一条生路。',
    category: 'action',
    tags: ['动作', '末日', '生存'],
    status: '连载中',
    updateDate: '2026-08-02',
    views: 3120400,
    rating: 4.8,
    chapters: [
      { id: 'ch-007-1', title: '第1话 零号病人', number: 1, updateDate: '2026-04-01', pages: [] },
      { id: 'ch-007-2', title: '第2话 逃离城市', number: 2, updateDate: '2026-04-08', pages: [] },
      { id: 'ch-007-3', title: '第3话 集结幸存者', number: 3, updateDate: '2026-04-15', pages: [] },
      { id: 'ch-007-4', title: '第4话 补给争夺', number: 4, updateDate: '2026-04-22', pages: [] },
      { id: 'ch-007-5', title: '第5话 安全区', number: 5, updateDate: '2026-04-29', pages: [] },
      { id: 'ch-007-6', title: '第6话 背叛', number: 6, updateDate: '2026-05-06', pages: [] },
      { id: 'ch-007-7', title: '第7话 丧尸王', number: 7, updateDate: '2026-05-13', pages: [] },
      { id: 'ch-007-8', title: '第8话 黎明之前', number: 8, updateDate: '2026-05-20', pages: [] },
      { id: 'ch-007-9', title: '第9话 疫苗', number: 9, updateDate: '2026-05-27', pages: [] },
      { id: 'ch-007-10', title: '第10话 希望之光', number: 10, updateDate: '2026-06-03', pages: [] },
    ],
  },
  {
    id: 'comic-008',
    title: '奇幻图书馆',
    author: '宋允儿',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20magical%20library%20cover%2C%20young%20girl%20opening%20glowing%20book%20in%20ancient%20library%2C%20floating%20sparkles%20and%20magical%20light%2C%20tall%20wooden%20bookshelves%2C%20warm%20amber%20lighting%2C%20mysterious%20atmosphere%2C%20manga%20art%20style%2C%20enchanting%20and%20dreamy%20vibe&width=400&height=560&seq=comic-cover-008&orientation=portrait',
    description: '在一家古老的图书馆里，每一本书都连接着另一个世界。图书管理员林小雅拥有穿越书中世界的神奇能力。她将在不同的故事中冒险，帮助书中角色完成未竟的使命。',
    category: 'fantasy',
    tags: ['奇幻', '穿越', '冒险'],
    status: '连载中',
    updateDate: '2026-08-01',
    views: 892100,
    rating: 4.5,
    chapters: [
      { id: 'ch-008-1', title: '第1话 古书的召唤', number: 1, updateDate: '2026-05-01', pages: [] },
      { id: 'ch-008-2', title: '第2话 童话之国', number: 2, updateDate: '2026-05-08', pages: [] },
      { id: 'ch-008-3', title: '第3话 海盗传说', number: 3, updateDate: '2026-05-15', pages: [] },
      { id: 'ch-008-4', title: '第4话 未来世界', number: 4, updateDate: '2026-05-22', pages: [] },
      { id: 'ch-008-5', title: '第5话 魔法学院', number: 5, updateDate: '2026-05-29', pages: [] },
      { id: 'ch-008-6', title: '第6话 禁书区', number: 6, updateDate: '2026-06-05', pages: [] },
    ],
  },
  {
    id: 'comic-009',
    title: '无声的证词',
    author: '张民浩',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20crime%20mystery%20cover%2C%20forensic%20scientist%20examining%20evidence%20in%20dim%20laboratory%2C%20blue%20cold%20lighting%2C%20microscope%20and%20case%20files%20on%20desk%2C%20serious%20atmosphere%2C%20manga%20art%20style%2C%20investigative%20theme%2C%20professional%20and%20tense%20mood&width=400&height=560&seq=comic-cover-009&orientation=portrait',
    description: '法医秦明接手了一桩看似普通的案件，却发现了令人毛骨悚然的连环杀人真相。每一个死者身上都留下了精心设计的密码信息。这是一场与时间赛跑的智力博弈。',
    category: 'thriller',
    tags: ['悬疑', '推理', '法医'],
    status: '连载中',
    updateDate: '2026-07-30',
    views: 678400,
    rating: 4.6,
    chapters: [
      { id: 'ch-009-1', title: '第1话 无名女尸', number: 1, updateDate: '2026-06-01', pages: [] },
      { id: 'ch-009-2', title: '第2话 死亡密码', number: 2, updateDate: '2026-06-08', pages: [] },
      { id: 'ch-009-3', title: '第3话 第二个受害者', number: 3, updateDate: '2026-06-15', pages: [] },
      { id: 'ch-009-4', title: '第4话 时间谜题', number: 4, updateDate: '2026-06-22', pages: [] },
      { id: 'ch-009-5', title: '第5话 嫌犯现身', number: 5, updateDate: '2026-06-29', pages: [] },
      { id: 'ch-009-6', title: '第6话 完美不在场', number: 6, updateDate: '2026-07-06', pages: [] },
    ],
  },
  {
    id: 'comic-010',
    title: '猫咪咖啡厅',
    author: '安美英',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20webtoon%20cute%20cat%20cafe%20cover%2C%20fluffy%20cats%20playing%20in%20cozy%20cafe%20setting%2C%20young%20woman%20serving%20coffee%20surrounded%20by%20happy%20cats%2C%20soft%20pastel%20colors%2C%20warm%20and%20inviting%20atmosphere%2C%20manga%20illustration%20style%2C%20adorable%20and%20peaceful%20vibe&width=400&height=560&seq=comic-cover-010&orientation=portrait',
    description: '继承了祖母留下的老旧咖啡厅，意外发现这里成了附近流浪猫的秘密聚集地。从此，她的生活被这群毛茸茸的小家伙们彻底改变。温馨治愈的猫咪日常就此展开。',
    category: 'slice-of-life',
    tags: ['日常', '猫咪', '美食'],
    status: '连载中',
    updateDate: '2026-08-01',
    views: 445800,
    rating: 4.5,
    chapters: [
      { id: 'ch-010-1', title: '第1话 意外的遗产', number: 1, updateDate: '2026-05-10', pages: [] },
      { id: 'ch-010-2', title: '第2话 第一位喵客', number: 2, updateDate: '2026-05-17', pages: [] },
      { id: 'ch-010-3', title: '第3话 橘猫的烦恼', number: 3, updateDate: '2026-05-24', pages: [] },
      { id: 'ch-010-4', title: '第4话 新来的小黑', number: 4, updateDate: '2026-05-31', pages: [] },
      { id: 'ch-010-5', title: '第5话 猫与人的羁绊', number: 5, updateDate: '2026-06-07', pages: [] },
      { id: 'ch-010-6', title: '第6话 重逢', number: 6, updateDate: '2026-06-14', pages: [] },
    ],
  },
  {
    id: 'comic-011',
    title: '复仇女王',
    author: '柳真雅',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20revenge%20drama%20cover%2C%20elegant%20woman%20in%20black%20dress%20looking%20back%20with%20determined%20expression%2C%20luxury%20penthouse%20night%20cityscape%20background%2C%20dramatic%20contrast%20lighting%2C%20dark%20red%20and%20black%20tones%2C%20manga%20art%20style%2C%20powerful%20and%20intense%20atmosphere&width=400&height=560&seq=comic-cover-011&orientation=portrait',
    description: '被最信任的人背叛，失去一切的她在五年后以全新的身份归来。这一次，她要让所有伤害过她的人付出代价。一部关于复仇与救赎的精彩故事。',
    category: 'drama',
    tags: ['剧情', '复仇', '都市'],
    status: '连载中',
    updateDate: '2026-08-02',
    views: 2013500,
    rating: 4.8,
    chapters: [
      { id: 'ch-011-1', title: '第1话 坠入深渊', number: 1, updateDate: '2026-04-15', pages: [] },
      { id: 'ch-011-2', title: '第2话 五年之后', number: 2, updateDate: '2026-04-22', pages: [] },
      { id: 'ch-011-3', title: '第3话 华丽归来', number: 3, updateDate: '2026-04-29', pages: [] },
      { id: 'ch-011-4', title: '第4话 第一个目标', number: 4, updateDate: '2026-05-06', pages: [] },
      { id: 'ch-011-5', title: '第5话 棋局开始', number: 5, updateDate: '2026-05-13', pages: [] },
      { id: 'ch-011-6', title: '第6话 意外盟友', number: 6, updateDate: '2026-05-20', pages: [] },
      { id: 'ch-011-7', title: '第7话 陷阱', number: 7, updateDate: '2026-05-27', pages: [] },
      { id: 'ch-011-8', title: '第8话 反将一军', number: 8, updateDate: '2026-06-03', pages: [] },
    ],
  },
  {
    id: 'comic-012',
    title: '格斗之王',
    author: '权相佑',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20martial%20arts%20action%20cover%2C%20fighter%20in%20dynamic%20kick%20pose%20inside%20fighting%20arena%2C%20sweat%20and%20motion%20effects%2C%20crowd%20cheering%20in%20background%2C%20intense%20spotlight%20lighting%2C%20powerful%20energy%2C%20manga%20art%20style%2C%20sports%20action%20theme&width=400&height=560&seq=comic-cover-012&orientation=portrait',
    description: '曾经的格斗冠军因伤退役后沦为街头混混。一次偶然的机会，他遇到了改变他一生的人——一位隐退多年的传奇格斗大师。为了重回巅峰，他开始了更加艰苦的修炼之路。',
    category: 'action',
    tags: ['动作', '格斗', '热血'],
    status: '已完结',
    updateDate: '2026-06-30',
    views: 2756800,
    rating: 4.9,
    chapters: [
      { id: 'ch-012-1', title: '第1话 坠落的天才', number: 1, updateDate: '2026-02-01', pages: [] },
      { id: 'ch-012-2', title: '第2话 街头之战', number: 2, updateDate: '2026-02-08', pages: [] },
      { id: 'ch-012-3', title: '第3话 神秘师父', number: 3, updateDate: '2026-02-15', pages: [] },
      { id: 'ch-012-4', title: '第4话 地狱训练', number: 4, updateDate: '2026-02-22', pages: [] },
      { id: 'ch-012-5', title: '第5话 初战告捷', number: 5, updateDate: '2026-03-01', pages: [] },
      { id: 'ch-012-6', title: '第6话 宿敌登场', number: 6, updateDate: '2026-03-08', pages: [] },
      { id: 'ch-012-7', title: '第7话 败北', number: 7, updateDate: '2026-03-15', pages: [] },
      { id: 'ch-012-8', title: '第8话 新的领悟', number: 8, updateDate: '2026-03-22', pages: [] },
      { id: 'ch-012-9', title: '第9话 终极决赛', number: 9, updateDate: '2026-03-29', pages: [] },
      { id: 'ch-012-10', title: '第10话 王者归来', number: 10, updateDate: '2026-04-05', pages: [] },
    ],
  },
];